module.exports = __webpack_public_path__ + "img/DK15194413.40181b69.png";